<template>
  <div>
    <QS-scroller-box>
      <QS-h3-title :title="pageTitle" />
      <el-alert
      v-if="discardDesc"
        class="reject-alert"
        :title="discardDesc"
        type="error"
      />
      <QS-h4-title title="审核信息" />
      <QS-column-box :source="source" :column="column" :list="list"/>
      <div slot="bottomAction" class="button-container">
        <el-button @click="cancel"> 取消 </el-button>
        <el-button @click="lookApprovalDetail" type="primary">
          查看审批动态
        </el-button>
      </div>
    </QS-scroller-box>
    <!--  bizType 1 个人租赁应收审批 / 2租赁退车付款审批 / 3租赁退车收款审批 / 4支付宝支付解约 / 5网约钱包支付解约  -->
    <lookApprovalDetail ref="lookApprovalDetail" :bizId="this.id" :bizType="this.bizType"/>
  </div>
</template>

<script>
import { getWithholdApprovalForm } from '@/api/domain/approvals'
import lookApprovalDetail from '@/pages/finance/batchCollectionRecord/components/lookApprovalDetail'

export default {
  components: {
    lookApprovalDetail,
  },
  data() {
    return {
      pageTitle: '审核详情',
      discardDesc: '', // 失败原因
      column: 3,
      source: {},
      id: '',
      bizType: '',
      list: [
        { name: '所在部门', key: 'deptName' },
        { name: '相关订单', key: 'orderId' },
        { name: '承租人', key: 'customerName' },
        { name: '车型', key: 'carModel' },
        { name: '车牌号', key: 'plateNo' },
        { name: '解约原因', key: 'terminateReason' },
      ],
    }
  },
  methods: {
    // 查看审批动态
    lookApprovalDetail() {
      this.$refs.lookApprovalDetail.dialogVisible = true
    },
    cancel() {
      this.$router.back()
    },
  },
  created() {
    this.id = this.$route.query.bizId
    this.bizType = this.$route.query.bizType
    getWithholdApprovalForm({ // TODO: 服务端已下线该接口
      id: this.$route.query.id,
      bizId: this.$route.query.bizId,
      type: this.$route.query.bizType === 4 ? '30' : '20',
    }).then((res) => {
      this.source = res.data || {}
      if (this.$route.query.state === 20) {
        this.discardDesc = '审批撤回'
      }
      if (this.$route.query.state === 30) {
        this.discardDesc = `审批驳回: ${res.data.remarks || '--'}`
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.reject-alert {
  padding: 8px 10px;
  margin-bottom: 16px;
  margin-top: -8px;
}
.btn-cancel {
  margin-right: 12px;
}
.approval-reject {
  margin-left: 14px;
}
.button-container {
  display: flex;
}
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .qs-h4-container-left {
  font-size: 16px;
}

.company_photos {
  ::v-deep .el-form-item__label {
    min-width: 162px;
  }

  .images-list {
    font-size: 0;
    width: 500px;
    height: 200px;
    flex-wrap: wrap;

    img {
      width: 80px;
      height: 80px;
      margin-left: 12px;

      &:nth-child(1),
      &:nth-of-type(6) {
        margin-left: 0;
      }

      &:nth-of-type(n + 6) {
        margin-top: 16px;
      }
    }
  }
}
</style>
